import React, { useState } from 'react';
import { Button, Chip, Dialog, DialogTitle, DialogContent, DialogActions, FormControl, MenuItem, InputLabel, Select, } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { CustomFormulaTypes } from '../../../entities';
import { useColumnSelect } from '../../../hooks';
import theme from '../../theme';
var ChipWithMenu = function (_a) {
    var label = _a.label, destination = _a.destination;
    /* --- controller --- */
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(''), customFormula = _c[0], setCustomFormula = _c[1];
    var _d = useState(false), showDenominator = _d[0], setShowDenominator = _d[1];
    var _e = useState(''), denominator = _e[0], setDenominator = _e[1];
    var onCustomFormulaChange = useColumnSelect().onCustomFormulaChange;
    var handleClickOpen = function () {
        setOpen(true);
    };
    var handleClose = function () {
        setOpen(false);
    };
    /* --- view --- */
    var SelectableColumns = destination.columns.map(function (column, i) {
        return (React.createElement(MenuItem, { key: i, value: column.key, "data-id": column.id, "data-label": column.key, "data-denominator": column.id }, column.key));
    });
    var FormulaList = Object.values(CustomFormulaTypes).map(function (formula, i) {
        return (React.createElement(MenuItem, { key: i, value: formula.name, "data-customformula": formula.type, "data-denominator": formula.denominator }, formula.name));
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(ActionableChip, { label: label, onClick: handleClickOpen, color: "primary" }),
        React.createElement(Dialog, { fullWidth: true, maxWidth: "xs", open: open, onClose: handleClose, "aria-labelledby": "form-dialog-title" },
            React.createElement(DialogTitle, { id: "form-dialog-title" },
                "Measure Setting: ",
                label),
            React.createElement(DialogContent, null,
                React.createElement(FormControl, { fullWidth: true },
                    React.createElement(InputLabel, null, "Custom Formula"),
                    React.createElement(Select, { "aria-label": label, name: label, value: customFormula, onChange: function (event) {
                            onCustomFormulaChange(event, 'customformula');
                            setCustomFormula(event.target.value);
                            event.target.value === 'Weighted Average' ? setShowDenominator(true) : setShowDenominator(false);
                        } }, FormulaList)),
                showDenominator === true ? (React.createElement(FormControl, { fullWidth: true },
                    React.createElement(InputLabel, null, "Denominator"),
                    React.createElement(Select, { "aria-label": label, name: label, value: denominator, onChange: function (event) {
                            onCustomFormulaChange(event, 'denominator');
                            setDenominator(event.target.value);
                        } }, SelectableColumns))) : null),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: handleClose, color: "primary" }, "Close")))));
};
var ActionableChip = withStyles({
    colorPrimary: {
        backgroundColor: theme.palette.primary.light,
    },
    clickableColorPrimary: {},
    deletableColorPrimary: {},
    avatarColorPrimary: {},
    iconColorPrimary: {},
    deleteIconColorPrimary: {},
    deleteIconOutlinedColorPrimary: {},
})(Chip);
export default ChipWithMenu;
